import React from "react";
import { Link } from "react-router-dom";

const AIDemoSection = () => {
  return (
    <section
      className="py-5"
      style={{ background: "linear-gradient(135deg, #f8f8ff 0%, #fff8f4 100%)" }}
    >
      <div className="container">
        {/* Header */}
        <div className="text-center mb-4">
          <span
            className="badge mb-2 px-3 py-2"
            style={{
              background: "#5b1dff",
              color: "#fff",
              borderRadius: "20px",
              fontSize: "0.85rem",
            }}
          >
            🤖 Live AI Demo
          </span>
          <h2 className="mb-2">See Our AI in Action</h2>
          <p className="text-muted fs-5" style={{ maxWidth: "600px", margin: "0 auto" }}>
            This is a real AI assistant built for a French restaurant — handling bookings,
            answering questions and taking reservations, 24/7.
          </p>
        </div>

        {/* iframe embed */}
        <div
          className="rounded-4 overflow-hidden shadow"
          style={{
            border: "2px solid #e9e0ff",
            maxWidth: "900px",
            margin: "0 auto",
          }}
        >
          <iframe
            src="https://le-petit-bistrot.web.app"
            title="Le Petit Bistrot — Live AI Chatbot Demo"
            width="100%"
            height="700px"
            style={{ border: "none", display: "block" }}
            allow="clipboard-write"
          />
        </div>

        <p
          className="text-center text-muted mt-3"
          style={{ fontSize: "0.85rem" }}
        >
          Try asking about the menu, opening hours, or make a booking!
        </p>

        {/* CTA */}
        <div className="text-center mt-4">
          <p className="mb-3 fs-5">
            Want an AI assistant like this for your business?
          </p>
          <Link to="/ai-for-restaurants" className="theme-btn btn-one me-3">
            AI for Restaurants
          </Link>
          <Link to="/contact-us" className="theme-btn btn-three">
            Book a Free Demo
          </Link>
        </div>
      </div>
    </section>
  );
};

export default AIDemoSection;
